import { useContext, useMemo } from 'react';

import { PlusOutlined, MinusOutlined } from '@ant-design/icons';

import { GenericDataFormContext } from '../../../../../shared/contexts';
import { QUOTATION_BUTTON } from '../../../../../shared';
import { StepThreeFormContext } from '../../contexts/StepThreeForm';
import {
  ColSize,
  ContentSection,
  Form,
  InputNumberForm,
  RowSize,
  SelectForm,
} from '../../../../../../../../../shared/components';

export const HomePaymentMethods = () => {
  const { paymentMethods } = useContext(GenericDataFormContext);

  const {
    homePaymentMethodsForm,
    commertialConditions,
    setLabelButton,
    clearPrimaFieldsOnFormChange,
  } = useContext(StepThreeFormContext);

  const maxVariation = useMemo(
    () => commertialConditions?.puntosDeAumentoExtraPrimaVariable!,
    [commertialConditions]
  );
  const minVariation = useMemo(
    () => -commertialConditions?.puntosDeDisminucionExtraPrimaVariable!,
    [commertialConditions]
  );

  const prevValues = useMemo(
    () => ({
      prevEPVValue: commertialConditions?.porcentajeExtraPrimaVariable,
      prevCommissionValue: commertialConditions?.porcentajeDeComision,
    }),
    [commertialConditions]
  );

  //* on change variation set epv and commission value, and set state for requote.
  const onPaymentsMethodFormChange = (valueChanged: { variation: number }) => {
    setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
    clearPrimaFieldsOnFormChange();

    if (valueChanged?.variation?.toString().length) {
      const prevCommissionValue = Number(prevValues.prevCommissionValue);
      const prevEPVValue = Number(prevValues.prevEPVValue);

      if (prevCommissionValue !== undefined && prevEPVValue !== undefined) {
        homePaymentMethodsForm.setFieldValue(
          'extraVariable',
          prevEPVValue + valueChanged.variation
        );
        homePaymentMethodsForm.setFieldValue(
          'commission',
          prevCommissionValue + valueChanged.variation
        );
      }
    }
  };

  return (
    <Form
      formProps={{
        form: homePaymentMethodsForm,
        name: 'consortium-payment-methods-form',
        onValuesChange: onPaymentsMethodFormChange,
      }}
    >
      <ContentSection level='h3' title='Forma de pago y comisiones'>
        <RowSize>
          <ColSize size={20}>
            <SelectForm
              formProps={{
                label: 'Forma de pago:',
                name: 'paymentMethod',
              }}
              selectProps={{
                options: paymentMethods,
              }}
            />
          </ColSize>

          <ColSize size={20}>
            <InputNumberForm
              formProps={{
                label: 'Comisión:',
                name: 'commission',
              }}
              inputNumberProps={{
                readOnly: true,
                disabled: true,
                precision: 2,
              }}
            />
          </ColSize>

          <ColSize size={20}>
            <InputNumberForm
              formProps={{
                label: 'Extra prima variable:',
                name: 'extraVariable',
              }}
              inputNumberProps={{
                readOnly: true,
                disabled: true,
                precision: 2,
              }}
            />
          </ColSize>

          <ColSize size={20}>
            <InputNumberForm
              formProps={{
                label: 'Variación:',
                name: 'variation',
                initialValue: 0,
              }}
              inputNumberProps={{
                addonAfter: '%',
                controls: {
                  upIcon: <PlusOutlined />,
                  downIcon: <MinusOutlined />,
                },
                min: minVariation,
                max: maxVariation,
              }}
            />
          </ColSize>
        </RowSize>
      </ContentSection>
    </Form>
  );
};
